import axios from "axios";

export default {
  async getVendorsByTypes(type) {
    return await axios
      .get("vendors/vendor/by/type/" + type)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
  async getSeason(vendor_id) {
    return await axios
      .get(`private-vendor-offer/vendor-offer-season-by-vendor-id/${vendor_id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },

  async getOffers(vendor_id, season_id) {
    return await axios
      .get(
        `private-vendor-offer/get-offers-by-vendor-and-season?season_id=${season_id}&vendor_id=${vendor_id}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
  async getList(season_vendor_offer_id) {
    return await axios
      .get(`private-allocation/my-allocation-list/${season_vendor_offer_id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
  async getChildByMasterId(master_id) {
    return await axios
      .get(`private-allocation/get-child-by-masterId/${master_id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },

  async postBids(data) {
    return await axios
      .post(`private-vendor-bid`, { data: data })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
};
